import Vue from 'vue';
import App from './App.vue';
import router from './router';
import form from './components/form'
import inputs from './components/inputs'
import preview from './components/preview'

Vue.config.productionTip = false;

form.install(Vue)
inputs.install(Vue)
preview.install(Vue)

const data = {
    locale: 'nb_NO',
    translations: {},
    user: {
        isLoggedIn: false,
        firstName: '',
        lastName: '',
        email: '',
        companyId: '',
        lambdaToken: ''
    }
};

Vue.mixin({
    methods: {
        __(key) {
            if (this.$root.translations[key] && this.$root.translations[key][this.$root.locale]) {
                return this.$root.translations[key][this.$root.locale];
            }else {
                return key + '.' + this.$root.locale;
            }
        }
    }
});

new Vue({
    data: data,
    router,
    render: h => h(App),
}).$mount('#app');
